import {
  FileViewContent,
  FileViewHeader,
  FileViewWrapper,
  TextContent,
} from './styles';
import { Footer } from '../../molecules';
import { Move } from '@morph-mapper/ui';
import { useTextSelect } from '../../hooks';
import { Group } from '@mantine/core';
import { useText } from './use-text';
import { useTextHighlight } from '../../hooks/use-text-highlight';
import { useStore } from '../../context';

export const TextView = () => {
  const { pageNumber, numPages, getPageText, getPageOffset, nextPage, previousPage } =
    useText();
  const { getHighlightedContent } = useTextHighlight();
  const highlights = useStore(({ file: f }) => f.highlights);

  useTextSelect();

  return (
    <FileViewWrapper>
      <FileViewHeader>
        <Group>
          <Move
            into={false}
            onClick={previousPage}
            disabled={pageNumber <= 1}
          />
          {pageNumber} / {numPages}
          <Move onClick={nextPage} disabled={pageNumber >= numPages} />
        </Group>
      </FileViewHeader>
      <FileViewContent>
        <TextContent dangerouslySetInnerHTML={{ __html: getHighlightedContent(getPageText(), highlights, getPageOffset()) }} />
      </FileViewContent>
      <Footer />
    </FileViewWrapper>
  );
};
